// extracted by mini-css-extract-plugin
export default {"ariaButton":"ARIAButton__ariaButton__X8JkT"};
    if(module.hot) {
      // 1763020727471
      var cssReload = require("!../../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  